
import ogPagesMixins from '@/mixins/ogPagesMixins'
export default {
  mixins: [ogPagesMixins],
  async asyncData({ $axios }) {
    try {
      const statistics = await $axios.$get('/activity/statistics')
      return {
        statistics,
      }
    } catch (error) {
      console.log(error)
    }
  },
  data() {
    return {
      seoTitle: 'Компании | Мегасреда',
      seoDescription:
        'Выбирайте компании платформы, чью информацию хотите отслеживать. Рейтинг составлен на основе просмотров контента. Обновляется каждый день',
      seoH1: 'Все компании Мегасреды.',
      seoImage: {
        url: 'https://megasreda.ru/img/navigator/navigator_companys_ogg.jpg',
        urlVk:
          'https://megasreda.ru/img/navigator/navigator_companys_ogg-vk.jpg',
        urlTw: 'https://megasreda.ru/img/navigator/navigator_companys_ogg.jpg',
        type: 'image/jpeg',
        width: 1200,
        height: 630,
      },
      companys: [],
      page: this.$route.query?.page ? this.$route.query.page : 1,
      companysLimit: 20,
      companysCount: 0,
      isSearch: false,
      searchCount: 0,
      searchString: '',
      isFilter: false,
    }
  },
  async fetch() {
    try {
      await this.fetchCompanys()
    } catch (error) {
      console.log(error)
    }
  },
  computed: {
    companysOffset() {
      return (this.page - 1) * this.companysLimit
    },
    pageCount() {
      if (this.isSearch) {
        return Math.ceil(this.searchCount / this.companysLimit)
      } else {
        return Math.ceil(this.companysCount / this.companysLimit)
      }
    },
  },
  watch: {
    $route() {
      if (!this.$route.query?.page) {
        this.page = 1
        this.companys = []
        this.$fetch()
      }
      if (this.page === 1) {
        this.$router.push({
          query: {},
        })
      }
    },
  },
  methods: {
    async fetchCompanys() {
      const { companys, countAllCompanys, isSearch, searchCount } =
        await this.$axios.$get('/companys', {
          params: {
            limit: this.companysLimit,
            offset: this.companysOffset,
            searchString: this.searchString,
          },
        })

      this.isSearch = isSearch
      this.searchCount = searchCount

      if (this.companys?.length) {
        this.companys = this.companys.concat(companys)
      } else {
        this.companys = companys
      }
      this.companysCount = countAllCompanys
    },
    paginateClick() {
      this.companys = []
      this.$router.push({
        query: {
          ...this.$route.query,
          page: this.page,
        },
      })
      this.$fetch()
      this.$scrollTo('body')
    },
    loadMore() {
      this.page++
      this.$router.push({
        query: {
          ...this.$route.query,
          page: this.page,
        },
      })
      this.$fetch()
    },
    search(str) {
      this.companys = []
      this.page = 1
      this.$router.push({
        query: {},
      })
      this.searchString = str
      this.$fetch()
    },
    filters(_filters) {
      // console.log(filters)
    },
  },
}
